import React from "react";
import dynamic from "next/dynamic";
import UIButton from "./UIButton";
import { useRouter } from "next/router";

const Heading = dynamic(() => import("./UIHeading.js"));

const UINoRecordMessage = ({ Message, Button, Pathname, height, textLevel, width, background, className = "" }) => {
  const Router = useRouter();
  
  return (
    <div
      className={`noRecordMessage ${className}`.trim()}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        minHeight: height ? height : "80vh",
        background: background ? background : "#fff",
      }}
    >
      <img
        src={`https://cdn.hireside.com/cdn/images/Characters/RecordNotFound${
          Math.floor(Math.random() * 2) + 1
        }.png`}
        alt="No Data"
        width={width ? width : 300}
      />
      <br />
      <br />
      <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%", alignItems: "center" }}>
        {Message && (
          <Heading level={textLevel ? textLevel : 2}>{Message}</Heading>
        )}
        {Button && <UIButton style={{ width: 200 }} onClick={() => { Router.push(Pathname)}}>{Button}</UIButton>}
      </div>
    </div>
  );
};

export default React.memo(UINoRecordMessage);
